module.exports = __webpack_public_path__ + "static/PettingDoodle-ae3a90e30d8cb12d16a61b7dc8c03414.png";